// All mock data for Bagfluence — Indian context

export const STATS = [
  { value: 500, suffix: "+", label: "Creators Managed" },
  { value: 120, suffix: "+", label: "Campaigns Executed" },
  { value: 10, prefix: "₹", suffix: "Cr+", label: "Brand Spend Managed" },
  { value: 4.8, suffix: "x", label: "Average Campaign ROI", decimals: 1 },
];

export const BRAND_LOGOS = [
  "Nykaa",
  "Swiggy",
  "boAt",
  "Mamaearth",
  "Zomato",
  "CRED",
  "Myntra",
  "Licious",
  "Sugar",
  "Plum",
  "Bewakoof",
  "MakeMyTrip",
];

export const PLATFORMS = [
  { name: "Instagram", icon: "instagram" },
  { name: "TikTok", icon: "music" },
  { name: "YouTube", icon: "youtube" },
  { name: "Snapchat", icon: "ghost" },
  { name: "Twitter / X", icon: "twitter" },
  { name: "LinkedIn", icon: "linkedin" },
];

export const SERVICES = [
  {
    title: "Creator Discovery & Matching",
    desc: "AI-powered creator sourcing with audience verification, fake-follower checks, and brand-fit scoring.",
    icon: "search",
  },
  {
    title: "End-to-End Campaign Management",
    desc: "Strategy, creator onboarding, contracts, content review, posting calendar and final reporting — handled.",
    icon: "rocket",
  },
  {
    title: "Content Strategy & Briefs",
    desc: "Creative direction crafted to brand voice with concept boards, hooks and platform-native references.",
    icon: "pen-tool",
  },
  {
    title: "Performance Analytics",
    desc: "Real-time dashboards, attribution, audience demographics, and ROI reports your CMO can present.",
    icon: "line-chart",
  },
];

export const CREATORS = [
  {
    id: "cr-001",
    name: "Aanya Sharma",
    handle: "@aanya.wanders",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=faces",
    location: "Mumbai, MH",
    platforms: [{ name: "Instagram", followers: 450000 }, { name: "YouTube", followers: 92000 }],
    primaryPlatform: "Instagram",
    followers: 450000,
    er: 6.2,
    niches: ["Travel", "Lifestyle"],
    languages: ["English", "Hindi"],
    rating: 4.8,
    rateCard: { reel: 85000, post: 60000, story: 25000 },
    audience: { female: 62, male: 38, ageGroups: [{ age: "18-24", pct: 38 }, { age: "25-34", pct: 41 }, { age: "35-44", pct: 14 }, { age: "45+", pct: 7 }] },
    avgViews: 320000,
    notes: "Pro on shoot, great script flexibility. Repeat with Skyscanner Apr-2025.",
    history: [
      { campaign: "Skyscanner Summer Escapes", brand: "Skyscanner", date: "2025-04", deliverables: "2 Reels, 4 Stories", status: "Completed" },
      { campaign: "MakeMyTrip Hill Stories", brand: "MakeMyTrip", date: "2025-02", deliverables: "1 Reel, 1 Post", status: "Completed" },
    ],
  },
  {
    id: "cr-002",
    name: "Rohan Mehta",
    handle: "@rohan.techlab",
    avatar: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=200&h=200&fit=crop&crop=faces",
    location: "Bangalore, KA",
    platforms: [{ name: "YouTube", followers: 1200000 }, { name: "Instagram", followers: 280000 }],
    primaryPlatform: "YouTube",
    followers: 1200000,
    er: 4.8,
    niches: ["Tech", "Reviews"],
    languages: ["English", "Hindi"],
    rating: 4.9,
    rateCard: { reel: 180000, post: 120000, story: 45000 },
    audience: { female: 22, male: 78, ageGroups: [{ age: "18-24", pct: 31 }, { age: "25-34", pct: 48 }, { age: "35-44", pct: 16 }, { age: "45+", pct: 5 }] },
    avgViews: 680000,
    notes: "Strong CTR on affiliate links. Negotiates hard but delivers on time.",
    history: [
      { campaign: "boAt Wireless Launch", brand: "boAt", date: "2025-05", deliverables: "1 Long-form, 1 Short", status: "Completed" },
      { campaign: "CRED Pay Push", brand: "CRED", date: "2025-03", deliverables: "1 Long-form", status: "Completed" },
    ],
  },
  {
    id: "cr-003",
    name: "Priya Kapoor",
    handle: "@priya.styles",
    avatar: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&h=200&fit=crop&crop=faces",
    location: "Delhi, DL",
    platforms: [{ name: "Instagram", followers: 890000 }, { name: "TikTok", followers: 420000 }],
    primaryPlatform: "Instagram",
    followers: 890000,
    er: 7.1,
    niches: ["Fashion", "Beauty"],
    languages: ["English", "Hindi", "Punjabi"],
    rating: 4.7,
    rateCard: { reel: 140000, post: 90000, story: 35000 },
    audience: { female: 81, male: 19, ageGroups: [{ age: "18-24", pct: 46 }, { age: "25-34", pct: 38 }, { age: "35-44", pct: 12 }, { age: "45+", pct: 4 }] },
    avgViews: 540000,
    notes: "Top-3 fashion in Delhi. Excellent reel aesthetics.",
    history: [
      { campaign: "Nykaa Monsoon Glow", brand: "Nykaa", date: "2025-07", deliverables: "3 Reels, 6 Stories", status: "In Review" },
      { campaign: "Myntra EORS", brand: "Myntra", date: "2025-06", deliverables: "2 Reels", status: "Completed" },
    ],
  },
  {
    id: "cr-004",
    name: "Karthik Reddy",
    handle: "@karthik.eats",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces",
    location: "Hyderabad, TG",
    platforms: [{ name: "Instagram", followers: 320000 }],
    primaryPlatform: "Instagram",
    followers: 320000,
    er: 8.4,
    niches: ["Food", "Local"],
    languages: ["English", "Telugu", "Hindi"],
    rating: 4.6,
    rateCard: { reel: 55000, post: 38000, story: 18000 },
    audience: { female: 48, male: 52, ageGroups: [{ age: "18-24", pct: 34 }, { age: "25-34", pct: 45 }, { age: "35-44", pct: 16 }, { age: "45+", pct: 5 }] },
    avgViews: 410000,
    notes: "High save-rate, great for QSR launches.",
    history: [
      { campaign: "Swiggy Diwali Push", brand: "Swiggy", date: "2025-10", deliverables: "2 Reels, 3 Stories", status: "Pending" },
    ],
  },
  {
    id: "cr-005",
    name: "Sneha Iyer",
    handle: "@sneha.lifts",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces",
    location: "Pune, MH",
    platforms: [{ name: "Instagram", followers: 210000 }, { name: "YouTube", followers: 65000 }],
    primaryPlatform: "Instagram",
    followers: 210000,
    er: 9.2,
    niches: ["Fitness", "Wellness"],
    languages: ["English", "Marathi"],
    rating: 4.9,
    rateCard: { reel: 45000, post: 30000, story: 14000 },
    audience: { female: 71, male: 29, ageGroups: [{ age: "18-24", pct: 28 }, { age: "25-34", pct: 52 }, { age: "35-44", pct: 16 }, { age: "45+", pct: 4 }] },
    avgViews: 220000,
    notes: "Highest ER in roster. Authentic, niche-loyal audience.",
    history: [
      { campaign: "Mamaearth Skin First", brand: "Mamaearth", date: "2025-08", deliverables: "1 Reel", status: "Approved" },
    ],
  },
  {
    id: "cr-006",
    name: "Vikram Singh",
    handle: "@vikram.frames",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces",
    location: "Jaipur, RJ",
    platforms: [{ name: "Instagram", followers: 540000 }],
    primaryPlatform: "Instagram",
    followers: 540000,
    er: 5.4,
    niches: ["Photography", "Travel"],
    languages: ["English", "Hindi"],
    rating: 4.5,
    rateCard: { reel: 95000, post: 70000, story: 28000 },
    audience: { female: 44, male: 56, ageGroups: [{ age: "18-24", pct: 30 }, { age: "25-34", pct: 46 }, { age: "35-44", pct: 18 }, { age: "45+", pct: 6 }] },
    avgViews: 380000,
    notes: "Cinematic aesthetic; great for luxury travel & lifestyle.",
    history: [],
  },
  {
    id: "cr-007",
    name: "Meera Joshi",
    handle: "@meera.beauty",
    avatar: "https://images.unsplash.com/photo-1554151228-14d9def656e4?w=200&h=200&fit=crop&crop=faces",
    location: "Mumbai, MH",
    platforms: [{ name: "Instagram", followers: 720000 }, { name: "YouTube", followers: 180000 }],
    primaryPlatform: "Instagram",
    followers: 720000,
    er: 6.6,
    niches: ["Beauty", "Skincare"],
    languages: ["English", "Hindi"],
    rating: 4.8,
    rateCard: { reel: 120000, post: 85000, story: 32000 },
    audience: { female: 88, male: 12, ageGroups: [{ age: "18-24", pct: 42 }, { age: "25-34", pct: 41 }, { age: "35-44", pct: 13 }, { age: "45+", pct: 4 }] },
    avgViews: 460000,
    notes: "Holy-grail for Nykaa, Sugar, Plum.",
    history: [
      { campaign: "Nykaa Monsoon Glow", brand: "Nykaa", date: "2025-07", deliverables: "2 Reels, 4 Stories", status: "Submitted" },
    ],
  },
  {
    id: "cr-008",
    name: "Arjun Patel",
    handle: "@arjun.invests",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces&sig=2",
    location: "Ahmedabad, GJ",
    platforms: [{ name: "Instagram", followers: 380000 }, { name: "LinkedIn", followers: 120000 }],
    primaryPlatform: "Instagram",
    followers: 380000,
    er: 5.9,
    niches: ["Finance", "Business"],
    languages: ["English", "Hindi", "Gujarati"],
    rating: 4.7,
    rateCard: { reel: 80000, post: 55000, story: 22000 },
    audience: { female: 28, male: 72, ageGroups: [{ age: "18-24", pct: 22 }, { age: "25-34", pct: 54 }, { age: "35-44", pct: 18 }, { age: "45+", pct: 6 }] },
    avgViews: 240000,
    notes: "Strong for fintech, SaaS, B2B.",
    history: [
      { campaign: "CRED Pay Push", brand: "CRED", date: "2025-03", deliverables: "1 Reel, 1 Carousel", status: "Completed" },
    ],
  },
];

export const BRANDS = [
  { id: "br-001", name: "Nykaa", industry: "Beauty", manager: "Priya N.", activeCampaigns: 2, totalSpend: 4200000, status: "Active", contact: { email: "marketing@nykaa.com", phone: "+91 22 4500 0000" } },
  { id: "br-002", name: "Swiggy", industry: "Food-tech", manager: "Rahul S.", activeCampaigns: 1, totalSpend: 3100000, status: "Active", contact: { email: "growth@swiggy.in", phone: "+91 80 4500 0000" } },
  { id: "br-003", name: "boAt", industry: "Electronics", manager: "Aakash V.", activeCampaigns: 0, totalSpend: 2700000, status: "Active", contact: { email: "partner@boat.com", phone: "+91 22 4900 1234" } },
  { id: "br-004", name: "Mamaearth", industry: "Skincare", manager: "Priya N.", activeCampaigns: 1, totalSpend: 1850000, status: "Active", contact: { email: "brand@mamaearth.in", phone: "+91 124 4567 890" } },
  { id: "br-005", name: "Zomato", industry: "Food-tech", manager: "Rahul S.", activeCampaigns: 0, totalSpend: 980000, status: "Prospect", contact: { email: "deals@zomato.com", phone: "+91 124 6789 000" } },
  { id: "br-006", name: "CRED", industry: "Fintech", manager: "Aakash V.", activeCampaigns: 0, totalSpend: 1450000, status: "Active", contact: { email: "creators@cred.club", phone: "+91 80 6789 1234" } },
];

export const CAMPAIGN_STAGES = [
  "Lead",
  "Proposal Sent",
  "Negotiation",
  "Active",
  "Deliverables Pending",
  "In Review",
  "Completed",
  "Paid",
  "Archived",
];

export const CAMPAIGNS = [
  {
    id: "cm-001",
    name: "Nykaa Monsoon Glow",
    brand: "Nykaa",
    stage: "Active",
    creators: ["cr-003", "cr-007", "cr-005"],
    creatorCount: 8,
    startDate: "2025-07-01",
    endDate: "2025-08-15",
    budget: 1400000,
    objective: "Drive product trials for the Monsoon Glow line via creator reels.",
    platform: "Instagram",
    deliverables: [
      { creator: "cr-003", type: "Reel", due: "2025-08-05", status: "Approved", link: "https://instagram.com/p/x1" },
      { creator: "cr-007", type: "Reel", due: "2025-08-06", status: "Submitted", link: "https://instagram.com/p/x2" },
      { creator: "cr-005", type: "Reel", due: "2025-08-08", status: "Pending" },
    ],
  },
  {
    id: "cm-002",
    name: "boAt Wireless Launch",
    brand: "boAt",
    stage: "Completed",
    creators: ["cr-002", "cr-006"],
    creatorCount: 12,
    startDate: "2025-05-01",
    endDate: "2025-05-30",
    budget: 2200000,
    objective: "Launch the Airdopes 800 with tech & lifestyle creators.",
    platform: "YouTube, Instagram",
    deliverables: [
      { creator: "cr-002", type: "Long-form", due: "2025-05-15", status: "Approved", link: "https://youtube.com/x" },
      { creator: "cr-006", type: "Reel", due: "2025-05-18", status: "Approved" },
    ],
  },
  {
    id: "cm-003",
    name: "Swiggy Diwali Push",
    brand: "Swiggy",
    stage: "Proposal Sent",
    creators: ["cr-004"],
    creatorCount: 5,
    startDate: "2025-10-15",
    endDate: "2025-11-10",
    budget: 800000,
    objective: "Push Diwali combos via food and family creators across south India.",
    platform: "Instagram",
    deliverables: [
      { creator: "cr-004", type: "Reel", due: "2025-10-25", status: "Pending" },
    ],
  },
  {
    id: "cm-004",
    name: "Mamaearth Skin First",
    brand: "Mamaearth",
    stage: "Deliverables Pending",
    creators: ["cr-005", "cr-007"],
    creatorCount: 6,
    startDate: "2025-08-10",
    endDate: "2025-09-05",
    budget: 950000,
    objective: "Educate audiences on toxin-free skincare routine.",
    platform: "Instagram",
    deliverables: [
      { creator: "cr-005", type: "Reel", due: "2025-08-28", status: "Approved" },
      { creator: "cr-007", type: "Story", due: "2025-08-30", status: "Pending" },
    ],
  },
  {
    id: "cm-005",
    name: "CRED Pay Push",
    brand: "CRED",
    stage: "Paid",
    creators: ["cr-002", "cr-008"],
    creatorCount: 4,
    startDate: "2025-03-05",
    endDate: "2025-04-01",
    budget: 1450000,
    objective: "Increase CRED Pay activations among premium users.",
    platform: "YouTube, Instagram",
    deliverables: [],
  },
  {
    id: "cm-006",
    name: "Zomato Hyperlocal Tasting",
    brand: "Zomato",
    stage: "Negotiation",
    creators: [],
    creatorCount: 3,
    startDate: "2025-11-01",
    endDate: "2025-11-25",
    budget: 620000,
    objective: "Drive trials of Zomato Gold dine-out partners across Bangalore.",
    platform: "Instagram",
    deliverables: [],
  },
  {
    id: "cm-007",
    name: "Myntra EORS Hype",
    brand: "Myntra",
    stage: "Lead",
    creators: [],
    creatorCount: 0,
    startDate: "2025-12-01",
    endDate: "2025-12-15",
    budget: 1800000,
    objective: "Build hype + day-1 demand for End-of-Reason-Sale.",
    platform: "Instagram, YouTube",
    deliverables: [],
  },
];

export const LEAD_STAGES = [
  "New Lead",
  "Contacted",
  "Demo Scheduled",
  "Proposal Sent",
  "Negotiation",
  "Closed Won",
  "Closed Lost",
];

export const LEADS = [
  { id: "ld-001", company: "Plum", contact: "Anita Desai", email: "anita@plum.in", budget: "₹5L–₹10L", source: "Website", stage: "New Lead", date: "2025-09-12", notes: "Wants beauty creator reels for skincare line." },
  { id: "ld-002", company: "Bewakoof", contact: "Manish T.", email: "manish@bewakoof.com", budget: "₹10L–₹25L", source: "Referral", stage: "Contacted", date: "2025-09-10", notes: "Looking at festive collection campaign." },
  { id: "ld-003", company: "Licious", contact: "Sneha P.", email: "sneha@licious.in", budget: "₹15L+", source: "LinkedIn", stage: "Demo Scheduled", date: "2025-09-08", notes: "Premium meats. Wants food creators." },
  { id: "ld-004", company: "Sugar", contact: "Ritu K.", email: "ritu@sugarcosmetics.com", budget: "₹8L–₹12L", source: "Website", stage: "Proposal Sent", date: "2025-09-05", notes: "Lipstick line launch." },
  { id: "ld-005", company: "MakeMyTrip", contact: "Ankit J.", email: "ankit@mmt.com", budget: "₹20L+", source: "Inbound", stage: "Negotiation", date: "2025-09-01", notes: "Year-end travel push." },
  { id: "ld-006", company: "Boult Audio", contact: "Tarun S.", email: "tarun@boult.com", budget: "₹6L–₹10L", source: "Cold outreach", stage: "Closed Won", date: "2025-08-22", notes: "Tech creators for earbuds launch." },
  { id: "ld-007", company: "Wakefit", contact: "Naveen R.", email: "naveen@wakefit.co", budget: "₹4L–₹8L", source: "Website", stage: "Closed Lost", date: "2025-08-18", notes: "Budget mismatch." },
];

export const CASE_STUDIES = [
  {
    brand: "Nykaa",
    industry: "Beauty",
    objective: "Re-launch the Monsoon Glow skincare line with beauty creators.",
    metrics: { views: "12.4M", er: "6.8%", roi: "5.2x" },
    color: "from-pink-500/15 to-fuchsia-500/5",
  },
  {
    brand: "boAt",
    industry: "Consumer Electronics",
    objective: "Launch Airdopes 800 with tech & lifestyle creators.",
    metrics: { views: "21.8M", er: "4.9%", roi: "6.1x" },
    color: "from-cyan-500/15 to-blue-500/5",
  },
  {
    brand: "Swiggy",
    industry: "Food-tech",
    objective: "Drive Diwali combo trials in Tier-2 cities.",
    metrics: { views: "8.6M", er: "7.4%", roi: "4.4x" },
    color: "from-orange-500/15 to-amber-500/5",
  },
];

export const TESTIMONIALS = [
  {
    name: "Riya Bansal",
    role: "Head of Brand",
    company: "Nykaa",
    quote: "Bagfluence ran one of the cleanest creator campaigns we've had in two years. Reporting was investor-grade.",
    tag: "Beauty · Instagram",
  },
  {
    name: "Karan Mehta",
    role: "Marketing Director",
    company: "boAt",
    quote: "From shortlist to live posts in 11 days. Creator quality was 10x what we got from larger agencies.",
    tag: "Launch · YouTube + Instagram",
  },
  {
    name: "Sneha Iyer",
    role: "VP Growth",
    company: "Swiggy",
    quote: "They told us which creators NOT to pick — that's how we knew they actually knew our audience.",
    tag: "Performance · Instagram",
  },
];

export const FAQS = [
  { q: "How do you vet creators?", a: "Every creator passes audience verification (real-follower %, geo, age, gender), engagement-quality checks, and a manual brand-fit review by our strategy team." },
  { q: "What platforms do you work on?", a: "Instagram, YouTube, TikTok (where available), Snapchat, X (Twitter), and LinkedIn. We pick the platform mix per brief — not per trend." },
  { q: "What's the minimum campaign budget?", a: "Our typical campaigns start at ₹5L for focused micro-influencer plays, ₹15L+ for mid-tier launches, and ₹50L+ for celebrity/full-funnel programs." },
  { q: "How long does a campaign take?", a: "A standard campaign runs 3–5 weeks: 1 week of shortlist + brief, 1–2 weeks for shoot + approvals, 1–2 weeks of go-live + reporting." },
  { q: "How is ROI measured?", a: "We measure reach, ER, view-through, store-visit lift, attributed orders, and ROAS using UTM tracking, affiliate links, and platform analytics." },
  { q: "Do you work with micro-influencers?", a: "Yes — micro (10K–100K) and nano (under 10K) are our specialty when intent and authenticity matter more than reach." },
  { q: "Can you handle paid amplification?", a: "Absolutely. We whitelist creator handles, run boosted posts and partnership ads through brand accounts." },
  { q: "Do you sign exclusivity contracts?", a: "Standard contracts include category exclusivity for the campaign duration. Extended exclusivity is priced separately." },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Discovery Call", desc: "Understand brand goals, target audience, and KPIs.", icon: "phone" },
  { num: "02", title: "Creator Matching", desc: "Curate vetted creators with audience-fit + brand-safety scores.", icon: "users" },
  { num: "03", title: "Execute & Report", desc: "Run the campaign, track live performance, deliver an investor-grade report.", icon: "bar-chart-3" },
];

export const ACTIVITY = [
  { time: "2h ago", text: "Priya K. approved 'Nykaa Monsoon Glow' final reel from @priya.styles" },
  { time: "5h ago", text: "New lead: Plum (₹5L–₹10L) added to CRM" },
  { time: "Yesterday", text: "Campaign 'boAt Wireless Launch' marked Completed" },
  { time: "Yesterday", text: "Rohan M. updated rate card to ₹1.8L/long-form" },
  { time: "2d ago", text: "Proposal sent to Bewakoof for Festive Collection campaign" },
  { time: "2d ago", text: "Invoice ₹14L raised against Nykaa" },
];

export const REVENUE_MONTHS = [
  { month: "Apr", billed: 28, collected: 25 },
  { month: "May", billed: 34, collected: 30 },
  { month: "Jun", billed: 22, collected: 22 },
  { month: "Jul", billed: 41, collected: 36 },
  { month: "Aug", billed: 48, collected: 39 },
  { month: "Sep", billed: 52, collected: 44 },
];

export const PLATFORM_SPEND = [
  { name: "Instagram", value: 58 },
  { name: "YouTube", value: 24 },
  { name: "TikTok", value: 9 },
  { name: "LinkedIn", value: 5 },
  { name: "X", value: 4 },
];

export const TASKS = [
  { id: "t1", title: "Approve Nykaa reels (final cut)", assignee: "Priya N.", due: "2025-09-18", status: "In Progress", linked: "Nykaa Monsoon Glow" },
  { id: "t2", title: "Send Swiggy revised proposal v2", assignee: "Rahul S.", due: "2025-09-17", status: "To Do", linked: "Swiggy Diwali Push" },
  { id: "t3", title: "Negotiate rate with Karthik R.", assignee: "Aakash V.", due: "2025-09-19", status: "To Do", linked: "Karthik Reddy" },
  { id: "t4", title: "Send Mamaearth campaign report", assignee: "Priya N.", due: "2025-09-15", status: "Done", linked: "Mamaearth Skin First" },
  { id: "t5", title: "Update CRED final invoice", assignee: "Rahul S.", due: "2025-09-14", status: "Done", linked: "CRED Pay Push" },
  { id: "t6", title: "Source 5 fitness creators in Pune", assignee: "Aakash V.", due: "2025-09-20", status: "In Progress", linked: "Creator DB" },
];

export const TEAM = [
  { id: "u1", name: "Priya Nair", role: "Admin", email: "priya@bagfluence.com" },
  { id: "u2", name: "Rahul Sharma", role: "Manager", email: "rahul@bagfluence.com" },
  { id: "u3", name: "Aakash Verma", role: "Manager", email: "aakash@bagfluence.com" },
  { id: "u4", name: "Ishita Bhat", role: "Viewer", email: "ishita@bagfluence.com" },
];

// Helpers
export const formatFollowers = (n) => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
  return `${n}`;
};

export const formatINR = (paise) => {
  if (paise >= 10_000_000) return `₹${(paise / 10_000_000).toFixed(2)}Cr`;
  if (paise >= 100_000) return `₹${(paise / 100_000).toFixed(1)}L`;
  if (paise >= 1000) return `₹${(paise / 1000).toFixed(0)}K`;
  return `₹${paise}`;
};

export const getCreatorById = (id) => CREATORS.find((c) => c.id === id);
export const getCampaignById = (id) => CAMPAIGNS.find((c) => c.id === id);
